import React from "react";
import { Badge } from "../ui/badge";

const STATUS_VARIANTS = {
  active: { variant: "success", dotVariant: "success-dot" },
  scheduled: { variant: "success", dotVariant: "success-dot" },
  paid: { variant: "success", dotVariant: "success-dot" },
  success: { variant: "success", dotVariant: "success-dot" },
  "partial success": { variant: "gray-blue-outline", dotVariant: "success-dot" },
  open: { variant: "warning", dotVariant: "warning-dot" },
  overdue: { variant: "error", dotVariant: "error-dot" },
  error: { variant: "error", dotVariant: "error-dot" },
  canceled: { variant: "error", dotVariant: "error-dot" },
  cancelled: { variant: "error", dotVariant: "error-dot" },
  incomplete: { variant: "error", dotVariant: "error-dot" },
  incomplete_expired: { variant: "error", dotVariant: "error-dot" },
  unpaid: { variant: "error", dotVariant: "error-dot" },
  paused: { variant: "warning", dotVariant: "warning-dot" },
  past_due: { variant: "warning", dotVariant: "warning-dot" },
  void: { variant: "gray", dotVariant: "gray-dot" },
  uncollectible: { variant: "gray", dotVariant: "gray-dot" },
  draft: { variant: "gray", dotVariant: "gray-dot" },
  default: { variant: "default", dotVariant: "gray-dot" },
};

export default function BadgeTag({ text, className = "", dot = false, dotBadge = "gray" }) {
  if (!text) return null;

  const label = `${text}`.trim();
  if (!label) return null;

  const normalizedStatus = label.toLowerCase();
  const { variant, dotVariant } = STATUS_VARIANTS[normalizedStatus] ?? STATUS_VARIANTS.default;
  const combinedClassName = className ? `capitalize ${className}` : "capitalize";

  if (dot) {
    return (
      <Badge variant={variant} className={combinedClassName}>
        <Badge size="dot" variant={dotVariant} className="mr-1" />
        {label}
      </Badge>
    );
  }

  return (
    <Badge variant={variant} className={combinedClassName}>
      {label}
    </Badge>
  );
}
